import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';

// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  ToggleButtonGroup,
  ToggleButton,
  Grid

} from '@mui/material';

import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../components/_dashboard/user';
//
import USERLIST from '../_mocks_/user';
import Request from '../components/common/Request';
import {  Paths, GetAzurePath, AzurePaths } from '../components/common/Constants';

import { Link as RouterLink } from 'react-router-dom';
import { useRouter } from "../components/common/use-router.js";
import { 
  DataGrid,
  GridActionsCellItem
} from '@mui/x-data-grid';

import {  useTranslation } from 'react-i18next';
import EditIcon from '@mui/icons-material/Edit';
import '../App.css';



// ----------------------------------------------------------------------


export default function Ranking() {
  const {t, i18n} = useTranslation();
  const router = useRouter(); 
  const editUser = React.useCallback(
    (id) => () => {
        setActionUserId(id);
        setTimeout(() => {
          router.push("/dashboard/users/edit/" + id );
        });
    },
    [],);

  /*      const { id, name, UserName,DurationInMs,Speed, status, avatarUrl, CreatedAtStr, PictureChangedAtTicks } = row; */
  const columns = React.useMemo( () =>   [
    { field: 'name', headerName: t("ranking_name"), width: 250, 
      renderCell:(params) => {
        if (params.row.PictureChangedAtTicks <= 0){
          return <Stack direction="row"> <Avatar  /> <span className="MuiDataGrid-cell MuiDataGrid-cell--textLeft"> {params.value}</span> </Stack>;
        }
        return  <Stack direction="row"> <Avatar src={GetAzurePath( AzurePaths.UserImageThumb + params.row.UserId)} /> <span className="MuiDataGrid-cell MuiDataGrid-cell--textLeft"> {params.value}</span> </Stack>;
        
      }
    },
    { field: 'DurationInMs', headerName: t("ranking_duration"), 
      renderCell:(params) => {
        return <div> { params.value / 1000 } s </div>
        
      }
    },
    { field: 'Speed', headerName: t("ranking_speed"),
      renderCell:(params) => {
        return <div> { params.value } km/h</div>
      }  
    },
    { field: 'CreatedAt', headerName: t("ranking_created_at"),     
        type: 'dateTime',
        valueGetter: ({ value }) => value && new Date(value),
        width: 250,
        renderCell:(params) => {
          return <div> { params.value.toLocaleString(i18n.language) }</div>
          
        } 
    },
    // { field: 'status', headerName: 'status'},
    {
        field: 'actions',
        type: 'actions',
        width: 80,
        getActions: (params) => [
            <div>
                <GridActionsCellItem
                  icon={<EditIcon />}
                  label="Delete"
                  onClick={editUser(params.id)} />
            </div>
        ]
    }
  ], [ editUser, t]);


  const timeSpans = [ "alltime", "today" ];

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [actionUserId, setActionUserId] = useState(null);
  const [orderBy, setOrderBy] = useState('Username');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [filteredData, setFilteredData] = useState(null);
  const [fullData, setFullData] = useState(null);

  const [routes, setRoutes] = useState(null);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [timeSpan, setTimeSpan] = useState(timeSpans[0]);


  const [filterModel, setFilterModel] = React.useState({items : []});

  const [sortModel, setSortModel] = React.useState([
    { field: 'DurationInMs', sort: 'asc' },
  ]);




  const ticksToDate = (ticks) => {
    //ticks are in nanotime; convert to microtime
    var ticksToMicrotime = ticks / 10000;

    //ticks are recorded from 1/1/1; get microtime difference from 1/1/1/ to 1/1/1970
    var epochMicrotimeDiff = Math.abs(new Date(0, 0, 1).setFullYear(1));

    //new date is ticks, converted to microtime, minus difference from epoch microtime
    var tickDate = new Date(ticksToMicrotime - epochMicrotimeDiff);
    return tickDate;
  }

  useEffect(async () =>{
    
    var result = await Request.Get(Paths.Ranking);


    setRoutes(result.data.Slides);



    //mainInfo.TopRides = GetTopRides(TopRides);
    //mainInfo.TopRidesToday = GetTopRides(TopRidesToday);
    var data = result.data;
    data.TopRides.forEach(element => {
      element.id = element.UserId;
      element.name = element.UserName;
      element.status = "active";
      element.avatarUrl = GetAzurePath( AzurePaths.UserImageThumb + element.UserId);
      element.CreatedAt = ticksToDate(element.CreatedAtTicks);
      element.CreatedAtStr = element.CreatedAt.toString();
    });
    data.TopRidesToday.forEach(element => {
      element.id = element.UserId;
      element.name = element.UserName;
      element.status = "active";
      element.avatarUrl = GetAzurePath( AzurePaths.UserImageThumb + element.UserId);
      element.CreatedAt = ticksToDate(element.CreatedAtTicks);
      element.CreatedAtStr = element.CreatedAt.toString();
    });

    

    setFullData(data);

    var selectedRoute = result.data.Slides[0].SlideId;
    setSelectedRoute(selectedRoute);

  }, []);

  useEffect(  async() => {

    if (fullData !== null && selectedRoute !== null){
      if (timeSpan == timeSpans[0]){
        var filteredData =  fullData.TopRides.filter((value) => value.SlideId === selectedRoute);
      }
      else{
        var filteredData =  fullData.TopRidesToday.filter((value) => value.SlideId === selectedRoute);
      }
     
      setFilteredData(filteredData);
  
    }

  }, [fullData, selectedRoute, timeSpan]);



/* DIALOG */
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);

  const handleConfirmFailed = async () => {
    setConfirmDialogOpen(false);
    setActionUserId(null);
  };

  const handleConfirmSuccess = async () => {
    setConfirmDialogOpen(false);

    var result = await Request.Delete(Paths.DeleteUser.replace("{id}", actionUserId));
    if (result.ok){
      alert("done");

      var filtered = filteredData.filter(function(value, index, arr){ 
        return value.id != actionUserId;
      });
      setFilteredData(filtered);
      setSelected([]);
    }
    setActionUserId(null);
  };


  if (filteredData == null){
    return <Page title={t("ranking_title")}><Container></Container></Page>
  }

  return (
    <Page title={t("ranking_title")}  className="ranking">


      <Dialog
        open={confirmDialogOpen}
        keepMounted
        onClose={handleConfirmFailed}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Use Google's location service?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Let Google help apps determine location. This means sending anonymous
            location data to Google, even when no apps are running.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmFailed}>Disagree</Button>
          <Button onClick={handleConfirmSuccess}>Agree</Button>
        </DialogActions>
      </Dialog>

      <Container  maxWidth="xxl">
        {/* <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t("ranking_title")}
          </Typography>

        </Stack> */}


    

        <Card>
          {/* <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
          /> */}
        
        <Stack
          className="blueOnWhiteContainer "
          
          direction="row"
          justifyContent="space-between"
          alignItems="center">

        <ToggleButtonGroup
          // style={{ "margin-left" : "0px"}}
                sx={{ mt: 2, ml:3 }}
                color="primary"
                value={selectedRoute}
                exclusive
                onChange={ (event, value) => { 
                  if (value != null )  
                    setSelectedRoute(value);                  
                }}>

                  {routes.map( (item, i) => {
                    return  <ToggleButton key={item.SlideId} value={item.SlideId}>{item.Name}</ToggleButton>;
                  })}

          </ToggleButtonGroup>


          <ToggleButtonGroup
                sx={{ mt: 2, ml:3 }}
                color="primary"
                value={timeSpan}
                exclusive
                onChange={ (event, value) => {  
                  if (value != null )  
                    setTimeSpan(value);  
                }}>
              {timeSpans.map( (item, i) => {
                    return  <ToggleButton key={i} value={item}>{t(item)}</ToggleButton>;
                  })}


          </ToggleButtonGroup>
        </Stack>


        <Scrollbar className="scrollableDataGrid">
          <TableContainer>
              <div style={{ height: 650, width: '100%' }}>
                  { filteredData != null && <DataGrid 
                  rows={filteredData} 
                  columns={columns}  
                  sortModel={sortModel}
                  onSortModelChange={(model) => setSortModel(model)}
                  filterModel={filterModel}
                  onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
                  />
              }
              </div>
          </TableContainer>
        </Scrollbar>


        


        </Card>
      </Container>
    </Page>
  );
}
